import { render } from "./EmployeePendingPrs.vue?vue&type=template&id=f639668e"
import script from "./EmployeePendingPrs.vue?vue&type=script&lang=js"
export * from "./EmployeePendingPrs.vue?vue&type=script&lang=js"

import "./EmployeePendingPrs.vue?vue&type=style&index=0&id=f639668e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__